import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { selectIsAuthenticated } from "../../../redux/auth";
import PropTypes from "prop-types";
import { LOGO_THEME } from "../../../constants/logo";
import { APP_PATHS } from "../../../constants/paths";
import darkLogo from "../../../assets/icons/dark_logo.svg";
import whiteLogo from "../../../assets/icons/white_logo.svg";
import classes from "./Logo.module.css";

const Logo = (props) => {
  const { theme, className } = props;
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { pathname } = useLocation();

  return (
    <Link
      to={
        isAuthenticated &&
        pathname !== APP_PATHS.LANDING.url &&
        pathname !== APP_PATHS.POLICY.url
          ? APP_PATHS.CATEGORIES.url
          : APP_PATHS.LANDING.url
      }
      className={classNames(classes["logo"], className)}
    >
      <img
        src={theme === LOGO_THEME.WHITE ? whiteLogo : darkLogo}
        alt="mtor logo"
        className={classes["logo__image"]}
      />
    </Link>
  );
};

export default Logo;

Logo.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.string,
};
